import { render, staticRenderFns } from "./RegisterCard.vue?vue&type=template&id=a61297da&scoped=true"
import script from "./RegisterCard.vue?vue&type=script&lang=ts"
export * from "./RegisterCard.vue?vue&type=script&lang=ts"
import style0 from "./RegisterCard.vue?vue&type=style&index=0&id=a61297da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61297da",
  null
  
)

export default component.exports